module.exports = __webpack_public_path__ + "static/media/10_The broken mirror_SE.e2f1171a.txt";